export default __webpack_public_path__ + "static/media/room-garden-illustration.17871ab0.png";